seo:
  siteTitle: Tale documentation
  ogImageAlt: Tale logo
nav:
  homeAriaLabel: Tale documentation home
  sidebarAriaLabel: Documentation
  groups:
    start: Start here
    cloud: Cloud
    selfHosted: Self-hosted
    install: Install
    configuration: Configuration
    operate: Operate
    observability: Observability
    security: Security
    releaseNotes: Release notes
    authentication: Authentication
    platform: Platform
    chat: Chat
    workspace: Workspace
    agents: Agents
    automations: Automations
    knowledge: Knowledge
    connectors: Connectors
    member: Member
    editor: Editor
    developer: Developer
    admin: Admin
    tutorials: Tutorials
    develop: Development
    projects: Projects
    approvals: Approvals
    governance: Governance
    legal: Legal
    tutorialsAdmin: Admin
    tutorialsEditor: Editor
    tutorialsDeveloper: Developer
    tutorialsMember: Member
    tutorialsVideos: Videos
docs:
  home: Home
pwa:
  updateAvailableTitle: Update available
  updateAvailableDescription: A new version of the docs is ready.
  updateNow: Reload
  updateLater: Later
  dismiss: Dismiss
  offlineReady: The offline screen is ready.
